export const GET_MAINTENANCEMODE_ABORTED = 'GET_MAINTENANCEMODE_ABORTED';
export const GET_MAINTENANCEMODE_REQUESTED = 'GET_MAINTENANCEMODE_REQUESTED';
export const GET_MAINTENANCEMODE_COMPLETED = 'GET_MAINTENANCEMODE_COMPLETED';
export const GET_MAINTENANCEMODE_FAILED = 'GET_MAINTENANCEMODE_FAILED';
